export const INIT_SCANNER_DATA = 'INIT_SCANNER_DATA';
export const GET_SCANNER_HEADER_COLUMNS = 'GET_SCANNER_HEADER_COLUMNS';
export const GET_SCANNER_COLUMNS = 'GET_SCANNER_COLUMNS';
export const FETCH_SCANNER_RESULTS = 'FETCH_SCANNER_RESULTS';
export const FETCH_SCANNER_EXISTING_RESULTS = 'FETCH_SCANNER_EXISTING_RESULTS';
export const SET_NUMBER_OF_SCANNED_RESULTS = 'SET_NUMBER_OF_SCANNED_RESULTS';
export const GET_SCANNER_STATUS = 'GET_SCANNER_STATUS';
export const AUTO_REFERSH_SCANNER = 'AUTO_REFERSH_SCANNER';
export const DISPATH_SCANNER_SELECTED_ROWS = 'DISPATH_SCANNER_SELECTED_ROWS';
export const DISPATH_SCANNER_ALL_SELECTED_ROWS = 'DISPATH_SCANNER_ALL_SELECTED_ROWS';
export const DISPATCH_SCANNER_APPROVED_ROWS = 'DISPATCH_SCANNER_APPROVED_ROWS';
export const DISPATCH_SCANNER_SELECTED_ACTION_ROW = 'DISPATCH_SCANNER_SELECTED_ACTION_ROW';
